import { HTMLPrinter } from "../global/htmlprinter";
import { VIEWERFEATURE } from "./debugMenu";
export function writeDebugMenuEntry(onclickString, text, entryID = "") {
    const p = HTMLPrinter;
    const idstring = entryID !== "" ? p.id(entryID) : "";
    return p.liWithProps(idstring)(p.a(p.emptyhref, p.onclick(onclickString))(text));
}
export function toggleDebugFeatures(featureName) {
    VIEWERFEATURE[featureName] = !VIEWERFEATURE[featureName];
    $("#debug_" + featureName).html(featureName + " : "
        + (VIEWERFEATURE[featureName] ? "<strong class = 'greenFont'>an</strong>" : "<strong class = 'redFont'>aus</strong>"));
}
export function changeDebugNumber(inputElement, featureName) {
    if (isNaN(parseFloat(inputElement.value))) {
        inputElement.value = "0";
    }
    VIEWERFEATURE[featureName] = parseFloat(inputElement.value);
}
//# sourceMappingURL=debugMenuFunctions.js.map